import { render, staticRenderFns } from "./PolimixQualityParamByLotForm.vue?vue&type=template&id=244a458e&"
import script from "./PolimixQualityParamByLotForm.vue?vue&type=script&lang=js&"
export * from "./PolimixQualityParamByLotForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports